import { Dimensions } from "@faire/slate/foundation/dimensions";

import { SpinnerSize } from "./type";

export const getSpinnerSize = (size?: SpinnerSize) => {
  switch (size) {
    case "xLarge":
      return Dimensions.rem[12];
    case "large":
      return Dimensions.rem[8];
    case "medium":
      return Dimensions.rem[6];
    case "small":
      return Dimensions.rem[4];
    case "xSmall":
    default:
      return Dimensions.rem[3];
  }
};

export const getSpinnerStrokeWidth = (size?: SpinnerSize) => {
  switch (size) {
    case "xLarge":
      return 1.5;
    case "large":
      return 2;
    case "medium":
      return 2.5;
    case "small":
      return 3.5;
    case "xSmall":
    default:
      return 4.5;
  }
};
